import { render, staticRenderFns } from "./DDragAndDrop.vue?vue&type=template&id=1a459596&scoped=true&lang=pug"
import script from "./DDragAndDrop.vue?vue&type=script&lang=js"
export * from "./DDragAndDrop.vue?vue&type=script&lang=js"
import style0 from "./DDragAndDrop.vue?vue&type=style&index=0&id=1a459596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a459596",
  null
  
)

export default component.exports